export { ContentTitle } from '../src/content-title/ContentTitle';
